import { useMutation } from "@apollo/react-hooks";
import { Button, Form, Input, message, Typography } from "antd";
import React from "react";
import { useHistory } from "react-router";
import ResetPasswordImage from "../../../Assets/Images/009.jpg";
import { CustIcon } from "../../../Components/Svgs";
import { FORGOT_PASSWORD } from "../../../Graphql/mutations";

const { Title } = Typography;

export const ForgotPasswordPage = () => {
  const history = useHistory();

  const [FORGOT_PASSWORD_MUTATION, { loading: passwordForgotting }] =
    useMutation(FORGOT_PASSWORD, {
      context: {
        headers: {
          nologin: 1,
        },
      },
    });

  const layout = {
    labelCol: {
      span: 24,
    },
    wrapperCol: {
      span: 24,
    },
  };
  const tailLayout = {
    wrapperCol: {
      span: 24,
    },
  };

  const onFinish = async (values) => {
    try {
      const response = await FORGOT_PASSWORD_MUTATION({
        variables: {
          email: values?.email.toLowerCase(),
        },
      });

      if (response?.errors) {
        message.error(response?.errors[0]?.message);
      } else if (response?.data?.forgotPassword?.status === "OK") {
        history.push("/login");
        message.success(response?.data?.forgotPassword?.message);
      } else {
        message.error("Something went wrong.");
      }
    } catch (err) {
      message.error("Could not reset password!");
    }
  };

  return (
    <div className="rowSec">
      <div className="colSec onBoardingLeft">
        <img src={ResetPasswordImage} alt="" className="" />
      </div>
      <div className="colSec onBoardingRight">
        <div className="login">
          <Title level={2}>
            <CustIcon type="left-arrow" onClick={() => history.goBack()} />
            Forgot Password
          </Title>
          <p className="subTitle">Fill the details below</p>
          <Form {...layout} name="basic" onFinish={onFinish}>
            <Form.Item
              label="Email"
              name="email"
              rules={[
                {
                  required: true,
                  message: "Please enter an email!",
                  whitespace: true,
                },
                {
                  type: "email",
                  message: "Enter Valid Email Address",
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item {...tailLayout} className="buttonSec">
              <Button
                loading={passwordForgotting}
                type="primary"
                shape="round"
                size="large"
                htmlType="submit"
              >
                Submit
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};
